// nginx serves the API under /api on the web app's own origin; in development
// it runs on its own port. REACT_APP_API_URL overrides both.
export const API_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:5001"
    : `${window.location.origin}/api`);

export const RELOAD_STORY = process.env.REACT_APP_RELOAD_STORY === "true";
